import { _logOut, _login } from 'src/services/redux/slices/auth/auth-slice';

let isRefreshing = false;
let failedQueue: any[] = [];

const processQueue = (error: any, token = null) => {
  failedQueue.forEach((prom: any) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

export default function setupAxios(axios: any, store: any) {
  axios.interceptors.request.use(
    (config: any) => {
      const {
        auth: { tokens },
      } = store.getState();
      if (tokens) {
        config.headers.Authorization = `Bearer ${tokens?.access?.token}`;
      }

      return config;
    },
    (err: any) => Promise.reject(err),
  );

  axios.interceptors.response.use(
    (response: any) => {
      return response;
    },
    async (error: any) => {
      const originalRequest = error?.config;

      // 401 Unauthorized ve token süresi bitti mesajı
      if (error?.response?.status === 401 && !originalRequest?._retry) {
        const {
          auth: { tokens },
        } = store.getState();

        // Eğer refresh token varsa, token yenilemeyi dene
        if (tokens?.refresh?.token && error?.response?.data?.message === 'Token süresi bitti') {
          originalRequest._retry = true;

          if (isRefreshing) {
            // Eğer zaten refresh işlemi devam ediyorsa, kuyruğa ekle
            return new Promise((resolve, reject) => {
              failedQueue.push({ resolve, reject });
            }).then((token) => {
              originalRequest.headers.Authorization = `Bearer ${token}`;
              return axios(originalRequest);
            });
          }

          isRefreshing = true;

          try {
            // Refresh token ile yeni token al
            const refreshResponse = await axios.post(`${process.env.REACT_APP_API_URL}/auth/refresh-token`, {
              refresh_token: tokens.refresh.token,
            });

            const newTokens = refreshResponse.data.tokens;
            const user = refreshResponse.data.user;

            // Redux store'u güncelle
            store.dispatch(
              _login({
                user,
                tokens: newTokens,
                isAuthorized: true,
                isJoyride: false,
              }),
            );

            // Başarılı refresh sonrası kuyruktaki istekleri işle
            processQueue(null, newTokens.access.token);

            // Orijinal isteği yeni token ile tekrar dene
            originalRequest.headers.Authorization = `Bearer ${newTokens.access.token}`;
            return axios(originalRequest);
          } catch (refreshError) {
            // Refresh token da geçersizse, logout yap
            processQueue(refreshError, null);
            await store.dispatch(_logOut());
            setTimeout(() => {
              window.location?.reload();
            }, 500);
            return Promise.reject(refreshError);
          } finally {
            isRefreshing = false;
          }
        } else if (tokens) {
          // Token varken farklı bir 401 hatası aldıysak logout yap
          await store.dispatch(_logOut());
          setTimeout(() => {
            window.location?.reload();
          }, 500);
        }
        // Token yoksa (login denemesi gibi), hatayı olduğu gibi ilet
      }

      // 503 Service Unavailable durumunda da logout yap
      if (error?.response?.status === 503) {
        await store.dispatch(_logOut());
        setTimeout(() => {
          window.location?.reload();
        }, 500);
      }

      return Promise.reject(error);
    },
  );
}
